
import { AppRouter } from './router/Router';
import usePreventPullToRefresh from './hooks/usePreventPullToRefresh';

function App() { 
  // Prevenir pull-to-refresh en móviles para no interferir con gráficas
  usePreventPullToRefresh();
  
  return (<AppRouter />) 
}

export default App;
